import { times } from 'lodash';
import { createSpeakingTaskType } from '../../createTaskType';
import { createSpeakingMessageItem } from "@dyl/task-types/sharedLogic/speakingItemCreators";
import SpeakingGenericEditor from "@dyl/task-types/sharedLogic/SpeakingGenericEditor";
import withProps from "@dyl/utils/withProps";
import speakingConvertToUploadFormat from "@dyl/task-types/sharedLogic/speakingConvertToUploadFormat";

export default createSpeakingTaskType({
    id: 'voice_messages',
    label: 'Voice Messages',
    skill: 'speaking',
    v2: true,
    hasRubric: false,

    editor: withProps(SpeakingGenericEditor, { disableTargets: true, includeContextAudioField: true }),
    createItemsTemplate: () => times(5, createSpeakingMessageItem),
    convertToUploadFormat: speakingConvertToUploadFormat,

    hasEndAudio: true,
    backgroundImages: {
        count: 1
    },
});